<template>
  <div :class="`chart coach-engagement md-layout-item md-size-${width} md-medium-size-${width} md-small-size-100`">
    <div>
      <h2>{{label}}</h2>
      <div>
        <apexchart :stacked="true" type=bar height=320 :options="chartOptions" :series="series" />
      </div>
      <div class="spacer">&nbsp;</div>
    </div>
  </div>
</template>

<script>
  import VueApexCharts from 'vue-apexcharts'

  export default {
    name: "CoachEngagement",
    computed: {},
    components: {
      apexchart: VueApexCharts
    },

    data() {
      let data = window.drupalSettings.controller.graphs.CoachEngagement.data;
      let series = [];
      let groupObservations = window.drupalSettings.controller.groupObservations;
      let groupAssignments = window.drupalSettings.controller.groupAssignments;
      let observationLabel = window.drupalSettings.group_catch_config.labels.observation_label;

        series.push({
        name: 'Reviews',
        data: data.map((item) => {
          return item.reviews;
        })
      });
      if (groupAssignments) {
        series.push({
          name: 'Assignments',
          data: data.map((item) => {
            return item.assignments;
          })
        });
      }
      if (groupObservations) {
        series.push({
          name: observationLabel,
          data: data.map((item) => {
            return item.observations;
          })
        });
      }

      let coaches = data.map((item) => {
        return item.name;
      });
      return {
        label: window.drupalSettings.controller.graphs.CoachEngagement.label,
        width: window.drupalSettings.controller.graphs.CoachEngagement.width || 33,
        series: series,
        chartOptions: {
          chart: {
            type: 'bar',
            stacked: true,
            toolbar: {
              show: false
            }
          },
          colors: ['#457c9d', '#83daf3', '#f6881f'],
          plotOptions: {
            bar: {
              horizontal: false,
              rangeBarOverlap: true,
              rangeBarGroupRows: false,
              dataLabels: {
                position: 'top',
                hideOverflowingLabels: true,
                orientation: 'horizontal'
              },
              columnWidth: '55%',
              //endingShape: 'rounded'

            },
          },
          dataLabels: {
            enabled: true,
            offsetY: 0,
            // formatter: function (val, opt) {
            //   if(val == 1) {
            //     return '';
            //   }
            // },
            style: {
              fontSize: '20px',
            },
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          legend: {
            fontSize: "14px",
            fontFamily: 'Source Sans Pro',
            offsetY: -5,
            labels: {
              colors: ['#3c3c3c'],
            },
            position: 'right',
            offsetY: 20
          },
          xaxis: {
            categories: coaches,
            labels: {
              style: {
                colors: ['#3c3c3c'],
                fontSize: '14px',
                fontFamily: 'Source Sans Pro',
              }
            },
            axisBorder: {
              show: true,
              color: '#cccccc',
            },
            axisTicks: {
              show: true,
              color: '#3c3c3c'
            },
          },
          yaxis: {
            title: {
              text: '',
              style: {
                color: '#3c3c3c',
                fontSize: '14px',
                fontFamily: 'Source Sans Pro',
              }
            },
            labels: {
              style: {
                color: '#3c3c3c',
                fontSize: "16px",
                fontFamily: 'Source Sans Pro'
              },
              formatter: function(val) {
                return val.toFixed(0)
              }
            },
            floating: false,
          },
          // fill: {
          //   type: 'gradient',
          //   gradient: {
          //     shade: 'dark',
          //     type: "vertical",
          //     shadeIntensity: 0.5,
          //     gradientToColors: ['#3D9AB9', '#FEA104'], // optional, if not defined - uses the shades of same color in series
          //     inverseColors: true,
          //     opacityFrom: 1,
          //     opacityTo: 1,
          //   }
          // },
          tooltip: {
            y: {
              formatter: function (val) {
                return val
              }
            }
          }
        }
      };
    },
  };
</script>
<style lang="scss">
.coach-engagement {
  .apexcharts-data-labels text{
    font-size: 12px;
    transform: translate(0px, -8px);
  }
}
</style>
